// Definitional tooltips per metric label. One-liners only — kept out of
// analytical territory so they stay safe to surface anywhere a label appears.
// Any label not listed here renders plain (no info icon, no tooltip).

export const METRIC_DEFINITIONS: Record<string, string> = {
  // Return / profit
  "Return": "Total percentage gain or loss on the initial balance.",
  "RETURN": "Total percentage gain or loss on the initial balance.",
  "Net Profit": "Gross profit minus gross loss - final dollar P&L.",
  "NET PROFIT": "Gross profit minus gross loss - final dollar P&L.",
  "Profit": "Total profit from closed trades.",
  "Gross Profit": "Sum of all winning trades before costs.",
  "Gross Loss": "Sum of all losing trades (absolute value).",
  "Dividends": "Income from holding long positions through ex-dividend dates.",
  "Swaps": "Overnight holding costs on leveraged positions.",
  "Commissions": "Broker fees deducted per trade.",
  "Best Trade": "Largest single winning trade in dollars.",
  "Worst Trade": "Largest single losing trade in dollars.",

  // Drawdown / risk
  "Max Drawdown": "Largest peak-to-trough drop in equity during the backtest.",
  "MAX DD": "Largest peak-to-trough drop in equity during the backtest.",
  "Max DD": "Largest peak-to-trough drop in equity during the backtest.",
  "Drawdown": "Peak-to-trough drop in equity.",
  "Recovery Factor": "Net profit divided by max drawdown. How many times your gain covers your worst dip.",
  "Risk/Reward": "Average winning trade divided by average losing trade. > 1 = winners bigger than losers.",

  // Risk-adjusted ratios
  "Sharpe Ratio": "Average return per unit of volatility. Higher = smoother ride. > 1 is good.",
  "Sharpe": "Average return per unit of volatility. Higher = smoother ride. > 1 is good.",
  "Sortino Ratio": "Like Sharpe, but only penalises downside volatility. Rewards strategies that avoid big losing streaks.",
  "Profit Factor": "Gross profit divided by gross loss. > 1 means the strategy made more than it lost.",

  // Trade counts
  "Total Trades": "Total number of trades executed during the backtest.",
  "Trades": "Total number of trades executed during the backtest.",
  "Winning": "Number of winning trades.",
  "Losing": "Number of losing trades.",
  "Long Trades": "Number of buy trades.",
  "Short Trades": "Number of sell / short trades.",
  "Longs Won": "Buy trades that closed in profit (count and hit rate).",
  "Shorts Won": "Sell trades that closed in profit (count and hit rate).",
  "Win Rate": "Percentage of trades that closed in profit.",
  "WIN RATE": "Percentage of trades that closed in profit.",
  "Win / Loss": "Winning trades vs losing trades.",

  // Per-trade economics
  "Avg Win": "Average profit on winning trades.",
  "Avg Win PnL": "Average profit on winning trades in dollars.",
  "Avg Loss": "Average loss on losing trades (absolute value).",
  "Avg Loss PnL": "Average loss on losing trades in dollars.",
  "Expectancy": "Average profit or loss per trade. Positive = edge.",
  "Avg Hold": "Average time a trade was held open.",
  "Avg. Trade Length": "Average time a trade was held open.",

  // Streaks (from Max DD subview)
  "Best / Worst Trade": "Best and worst single-trade results.",
  "Max Consec. Wins / Losses": "Longest consecutive winning streak and longest losing streak.",
  "Max Consec. Profit / Loss": "Biggest cumulative profit streak and biggest drawdown streak.",

  // Long/Short comparison metric labels (LONG_SHORT_METRICS)
  "Win Rate %": "Percentage of trades that closed in profit.",
  "Profit Factor ": "Gross profit divided by gross loss.", // sometimes trailing space in mock
  "Avg Profit ($)": "Average profit on winning trades in dollars.",
  "Avg Loss ($)": "Average loss on losing trades in dollars.",
  "Total P&L ($)": "Total dollar P&L from trades in this direction.",
  "Total Trades #": "Total trades executed in this direction.",

  // Extra entries for label strings used only in the migrated code
  "Net P&L": "Total dollar P&L from trades in this direction.",
  "Losing Trades": "Number of losing trades.",
}
